import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FileViewer }
  from 'Components/ComponentLibrary/Components/Uncategorized/FileViewer';
import { QueryVal } from 'Helpers/Query';
import {
  AttachmentsRebranded,
} from 'Components/ComponentLibrary/Components/Uncategorized/AttachmentsRebranded';
import fr from 'facet-rest';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('AttachmentsSectionRebranded', () => ({
  root: {
    flexGrow: 1,
  },
  wrap: {
    flexWrap: 'wrap',
  },
}));

const AttachmentsSectionRebranded = ({
  className,
  attachmentsCollection,
  AttachmentProps,
  eventCategory,
  ...rest
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const attachments = attachmentsCollection?.resources().list() || [];

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const attachmentSelfLink = QueryVal('attachmentSelfLink');

  useEffect(() => {
    if (!attachmentSelfLink) {
      return;
    }

    const attachmentIsInCollection = attachmentsCollection.resources().list().find(v => {
      return v.link('self').url() === attachmentSelfLink;
    });

    if (attachmentIsInCollection) {
      setIsPreviewOpen(true);
    }
  }, [attachmentSelfLink]);


  return (
    <div className={classNames(classes.root, className)} {...rest}>
      <AttachmentsRebranded
        attachmentResources={attachments}
        className={classes.wrap}
        AttachmentProps={AttachmentProps}
      />
      <FileViewer
        attachmentResources={attachments}
        isOpen={isPreviewOpen}
        closeModal={() => setIsPreviewOpen(false)}
        eventCategory={eventCategory}
      />
    </div>
  );
};

AttachmentsSectionRebranded.defaultProps = {
  className: '',
  AttachmentProps: {},
};

AttachmentsSectionRebranded.propTypes = {
  className: PropTypes.string,
  attachmentsCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  AttachmentProps: PropTypes.object,
  eventCategory: PropTypes.string.isRequired,
};

export { AttachmentsSectionRebranded };
